import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { removeToken } from "../../ auth";
import "bootstrap-icons/font/bootstrap-icons.css";
import logo from "../../assets/img/logoN.png";
import { fetchEgliseInfo } from "../../services/aspirantService";

export default function SidebarEglise() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [loadingInfo, setLoadingInfo] = useState(true);
  const [egliseInfo, setEgliseInfo] = useState(null);

  const isActive = (path) => location.pathname === path;
  const handleToggle = () => setIsOpen(!isOpen);
  const handleLogout = () => {
    removeToken();
    navigate("/");
  };

  useEffect(() => {
    const init = async () => {
      setLoadingInfo(true);
      try {
        const data = await fetchEgliseInfo();
        setEgliseInfo(data);
      } catch (err) {
        console.error("Erreur chargement des infos de l'église", err);
      } finally {
        setLoadingInfo(false);
      }
    };
    init();
  }, []);

  return (
    <>
      {/* Barre horizontale pour mobile */}
      <nav className="d-lg-none bg-dark text-white shadow-sm position-fixed top-0 start-0 end-0" style={{ zIndex: 1000 }}>
        <div className="container-fluid">
          <div className="d-flex align-items-center justify-content-between flex-wrap py-2">
            <div
              className="d-flex align-items-center cursor-pointer flex-grow-1"
              onClick={() => navigate("/dashboard-eglise")}
              style={{ cursor: "pointer", minWidth: 0 }}
            >
              <img 
                src={logo} 
                alt="logo" 
                style={{ height: "40px", marginRight: "10px", flexShrink: 0 }} 
              />
              <div className="d-flex flex-column" style={{ minWidth: 0, overflow: "hidden" }}>
                <span className="fs-6 fw-bold text-truncate">
                  Église {loadingInfo ? "Chargement..." : egliseInfo?.eglise?.name || "Non défini"}
                </span>
              </div>
            </div>
            <button
              className="btn btn-outline-light"
              type="button"
              onClick={handleToggle}
            >
              <i className={`bi ${isOpen ? "bi-x" : "bi-list"}`}></i>
            </button>
          </div>
          {/* Menu déroulant mobile */}
          <div className={`${isOpen ? "d-block" : "d-none"} pb-2`}>
            <div className="d-flex flex-column gap-2">
              <MobileNavLink 
                icon="people" 
                label="Gérer les élèves" 
                path="/dashboard-eglise/aspirants" 
                isActive={isActive} 
                onClick={() => {
                  navigate("/dashboard-eglise/aspirants");
                  setIsOpen(false);
                }} 
              />
              <MobileNavLink 
                icon="file-earmark-text" 
                label="Gérer les exigences"
                path="/dashboard-eglise/preuves" 
                isActive={isActive} 
                onClick={() => {
                  navigate("/dashboard-eglise/preuves");
                  setIsOpen(false);
                }} 
              />
              <button 
                className="btn btn-outline-danger btn-sm" 
                onClick={handleLogout}
              >
                <i className="bi bi-box-arrow-left me-1"></i>Déconnexion
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Sidebar vertical pour desktop */}
      <div
        className="d-none d-lg-flex flex-column bg-dark text-white shadow-sm p-3 justify-content-between"
        style={{ width: "250px", minHeight: "100vh", zIndex: 1000 }}
      >
        <div>
          <div
            className="d-flex flex-column align-items-center mb-4 cursor-pointer text-center"
            onClick={() => navigate("/dashboard-eglise")}
            style={{ cursor: "pointer" }}
          >
            <img 
              src={logo} 
              alt="logo" 
              style={{ height: "50px", marginBottom: "8px" }} 
            />
            <span className="fs-6 fw-bold">
              Église {loadingInfo ? "Chargement..." : egliseInfo?.eglise?.name || "Non défini"}
            </span>
          </div>

          <ul className="nav flex-column">
            <SidebarLink 
              icon="people" 
              label="Gérer les aspirants" 
              path="/dashboard-eglise/aspirants" 
              isActive={isActive} 
              onClick={() => navigate("/dashboard-eglise/aspirants")} 
            />
            <SidebarLink 
              icon="file-earmark-text" 
              label="Gérer les exigences"
              path="/dashboard-eglise/preuves" 
              isActive={isActive} 
              onClick={() => navigate("/dashboard-eglise/preuves")} 
            />
          </ul>
        </div>

        <div className="border-top pt-3 mt-3">
          <button className="btn btn-outline-danger w-100" onClick={handleLogout}>
            <i className="bi bi-box-arrow-left me-2"></i>Déconnexion
          </button>
        </div>
      </div>
    </>
  );
}

function SidebarLink({ icon, label, path, isActive, onClick }) {
  return (
    <li className="nav-item mb-3">
      <button
        className={`btn text-start text-white w-100 ${isActive(path) ? "fw-bold" : ""}`}
        onClick={onClick}
      >
        <i className={`bi bi-${icon} me-2`}></i>{label}
      </button>
    </li>
  );
}

function MobileNavLink({ icon, label, path, isActive, onClick }) {
  return (
    <button
      className={`btn text-white text-start w-100 ${isActive(path) ? "fw-bold bg-secondary" : ""}`}
      onClick={onClick}
    >
      <i className={`bi bi-${icon} me-2`}></i>{label}
    </button>
  );
} 